export const CA = "9b2TErku1jM8gd2DFVotGyXMdmPx2fcwvBuHPzqQpump";
export const X_URL = "https://x.com/BaldPigeonzc";
export const TELEGRAM_URL = "https://t.me/Baldpigeon";
export const GMGN_URL = `https://gmgn.ai/sol/token/${CA}`;
export const DEXSCREENER_PAIR = "FcurDHkzfQTU4dDR2hBWL4BYjYM9qXYZXPnmjcftusrj";
export const DEXSCREENER_URL = `https://dexscreener.com/solana/${DEXSCREENER_PAIR}`;
export const DEXSCREENER_EMBED = `${DEXSCREENER_URL}?embed=1&loadChartSettings=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=0&chartType=usd&interval=15`;
export const PUMPFUN_URL = `https://pump.fun/coin/${CA}`;
export const DEV_WALLET = "HdmQS1vKbeWFLLwaM3pzWMQE7H8NvawrNSSntbcGMf7g";
export const DEV_WALLET_SOLSCAN = `https://solscan.io/account/${DEV_WALLET}`;
export const DEV_WALLET_PUMPFUN = `https://pump.fun/profile/${DEV_WALLET}?tab=creator-rewards`;
export const PUMPFUN_CREATOR_URL = "https://pump.fun/join/BALDPIGEONDev";
export const CHARITY_NAME = "Cascadia Pigeon Rescue";
export const CHARITY_URL = "https://www.cascadiapigeonrescue.org/";
export const CHARITY_DONATE_URL = "https://givebutter.com/sCY6Qw";
export const CHARITY_PCT = 5;
export const FEE_SPLIT_TX =
    "https://solscan.io/tx/2ETQ27zUiWYEYK5KfsV7mP5SRRcwm1PCHyMp1bJZr1fCbu7tEqDxwyUkziScm7dQahVtzXRYeDukqr4u5ySgvcpT";
export const KYC_PROVIDER = "";
export const KYC_REPORT_URL = "";
export const AUDIT_PROVIDER = "";
export const AUDIT_REPORT_URL = "";
export const SOLSCAN_TOKEN_URL = `https://solscan.io/token/${CA}`;
export const BURN_TX =
    "https://solscan.io/tx/4qbpxZgbfPgVir7cqNYW6oWg53F8T3BjGSpv8jLFwv9mwf4FquK7zPPm3gaD6vBP5CD2ZvVF8rXaXSscy7fDM3Rq";
export const SUBMIT_MEME_INTENT = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    "Making the internet BALD 🧑‍🦲 @BaldPigeonzc #BALDPIGEON"
)}`;

export const SHORTEN = (addr, head = 6, tail = 6) =>
    addr && addr.length > head + tail + 3
        ? `${addr.slice(0, head)}…${addr.slice(-tail)}`
        : addr;
